import api from '@/shared/api/api';
import {
  Banner,
  BannerData,
  CreateBannerPayload,
  UpdateBannerPayload,
} from '../types';

const buildBannerFormData = (data: Partial<BannerData>, image?: File): FormData => {
  const form = new FormData();
  form.append('data', JSON.stringify(data));
  if (image) {
    form.append('image', image);
  }
  return form;
};

export const bannerApi = {
  list: async (signal?: AbortSignal): Promise<Banner[]> => {
    return api<Banner[]>({
      url: '/v1/admin/banners',
      method: 'GET',
      signal,
    });
  },

  get: async (id: string, signal?: AbortSignal): Promise<Banner> => {
    return api<Banner>({
      url: `/v1/admin/banners/${id}`,
      method: 'GET',
      signal,
    });
  },

  create: async (payload: CreateBannerPayload): Promise<Banner> => {
    const form = buildBannerFormData(payload.data, payload.image);
    return api<Banner>({
      url: '/v1/admin/banners',
      method: 'POST',
      data: form,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  update: async (id: string, payload: UpdateBannerPayload): Promise<Banner> => {
    const form = buildBannerFormData(payload.data, payload.image);
    return api<Banner>({
      url: `/v1/admin/banners/${id}`,
      method: 'PUT',
      data: form,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  remove: async (id: string): Promise<{ id: string; deletedAt: string }> => {
    return api({
      url: `/v1/admin/banners/${id}`,
      method: 'DELETE',
    });
  },
};
